import React from 'react';
import './LocationsConfig.css';

function LocationsConfig({ pendingConfig, setPendingConfig, isMobile }) {
  const preferenceKeys = [
    'relaxation',
    'adventure',
    'cultural',
    'nature',
    'luxury',
    'romantic',
    'family',
  ];
  
  const stepOptions = [
    { value: 0, label: 'Ignore' },
    { value: 0.5, label: 'Include' },
    { value: 1, label: 'Focus' },
  ];

  function getStepLabel(val) {
    if (val === 0) return 'Ignore';
    if (val === 0.5) return 'Include';
    if (val === 1) return 'Focus';
    return '';
  }

  if (isMobile) {
    return (
      <>
        <div className="locations-config-sliders-row-mobile">
          {preferenceKeys.map((key, idx) => (
            <div
              className="locations-config-slider-mobile"
              key={key}
            >
              <label>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
              <select
                value={pendingConfig[key]}
                onChange={e => {
                  const v = parseFloat(e.target.value);
                  setPendingConfig(cfg => ({ ...cfg, [key]: v }));
                }}
              >
                {stepOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          ))}
        </div>
      </>
    );
  } else {
    return (
      <div className="locations-config-desktop-container">
        {preferenceKeys.map((key, idx) => (
          <div
            key={key}
            className="locations-config-attribute-container"
          >
            <label className="locations-config-attribute-label">
              {key.charAt(0).toUpperCase() + key.slice(1)}
            </label>
            <input
              type="range"
              min={0}
              max={1}
              step={0.5}
              value={pendingConfig[key]}
              onChange={e => {
                const v = parseFloat(e.target.value);
                setPendingConfig(cfg => ({ ...cfg, [key]: v }));
              }}
              className="locations-config-range-input"
            />
            <span className="locations-config-range-label">
              {getStepLabel(pendingConfig[key])}
            </span>
          </div>
        ))}
        
        {/* Tuning Comments - Inline with Attributes */}
        <div className="locations-config-comments-container">
          <label className="locations-config-comments-label">
            Comments
          </label>
          <input
            type="text"
            placeholder="Tuning comments"
            value={pendingConfig.searchComment}
            onChange={e => {
              setPendingConfig(cfg => ({ ...cfg, searchComment: e.target.value }));
            }}
            className="locations-config-comments-input"
          />
        </div>
      </div>
    );
  }
}

export default LocationsConfig;
